import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ViewArchive from './icon-view-archive.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <ViewArchive {...validProps} />;
}
SvgComponent.iconName = 'viewArchive';

export const ViewArchiveIcon = svgIconWrapper(SvgComponent);
